export enum EmailNotificationType {
    notifyWinner = "notifyWinner",
    notifyOutbidUser = "notifyOutbidUser",
    notifyCurrentBidder = "notifyCurrentBidder",
    notifyAcquireNowBuyer = "notifyAcquireNowBuyer",
    notifyAcquireNowSeller = "notifyAcquireNowSeller",
    notifyClaimTokenUser = "notifyClaimTokenUser",
}
